import React, {forwardRef, useState, useEffect, Fragment} from 'react'
// import {useDispatch, useSelector} from "react-redux"
import MaterialTable from 'material-table'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import Autocomplete from '@material-ui/lab/Autocomplete'

// Material-UI Icon
// import EditIcon from '@material-ui/icons/Edit'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import DeleteIcon from '@material-ui/icons/Delete'
// import WallpaperIcon from '@material-ui/icons/Wallpaper'
// import PermDataSettingIcon from '@material-ui/icons/PermDataSetting'

// For Material-Table
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'

// Custom Component
import useLoading from "../Loading/useLoading"
import FullScreenDialog from '../Dialog/FullScreenDialog'
import DrawingDetail from './DrawingDetail'

// Custom Style
import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import viewCoverDrawingTableStyle from '../../styles/jss/components/drawingRegister/viewCoverDrawingTableStyle'

// Fetch Data
// import {getLatestDrawing, getPurposeType, getDrawingTypeAndGroup} from '../../dataSource/drawingRegister'


const useStyles = makeStyles(theme => viewCoverDrawingTableStyle(theme))
const groupStateData = [-1, -1, -1, -1, -1, -1, -1]

const ViewCoverDrawingTable = props => {
	const {coverDrawingRecord, annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()

	// Loading 
	const [getDrawingLoading, getDrawingShowLoading, getDrawingHiddenLoading] = useLoading()

	const [selectedDrawingRecord, setSelectedDrawingRecord] = useState(null)
	const [selectedDrawingRowId, setSelectedDrawingRowId] = useState(null)
	const [actionsIcon, setActionsIcon] = useState([])
	const [drawingDetailDialogOpen, setDrawingDetailDialogOpen] = useState(false)
	const [dataTableToolbarOpen, setDataTableToolbarOpen] = useState(true)


	const tableIcons = {
		Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
		Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
		Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
		DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
		Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
		Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
		FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
		LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
		NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
		ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
		SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
		ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
		ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
	}

	const columns = [
		{title: "DWG No", field: "dwg_no", width: "30%"},
		{title: "DWG Title", field: "dwg_title", width: "70%"},
	]


	// Dialog open and close central
	const drawingDetailDialogHandleOpen = () => {
		setDrawingDetailDialogOpen(true)
	}

	const drawingDetailDialogHandleClose = () => {
		setDrawingDetailDialogOpen(false)
	}

	// Dialog button declaration
	const drawingDetailDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	useEffect(() => {
	}, [])


	return (
		// console.log("Drawing Record under Cover | Variable: coverDrawingRecord (ViewCoverDrawingTable.js)"),
		// console.log(coverDrawingRecord),

		// console.log("---------------------------------------------------------------------------------"),

		<Fragment>
			<div>
				<FullScreenDialog
					open={drawingDetailDialogOpen}
					dialogTitle={"Drawing Detail"}
					formContent={
						<DrawingDetail
							selectedDrawing={selectedDrawingRecord}
							annotSaveChangeAction={annotSaveChangeAction}
							setAnnotSaveChangeAction={setAnnotSaveChangeAction}
						/>
					}
					button={drawingDetailDialogBtn}
					handleClose={drawingDetailDialogHandleClose}
				/>
			</div>

			<MaterialTable
				icons={tableIcons}
				title="Drawing Under the Cover"
				columns={columns}
				data={coverDrawingRecord}
				actions={actionsIcon}

				// onSearchChange={handleSearchChange}
				// onFilterChange={handleFilterChange}

				// onToggleDetailPanel={() => {
				// 	alert("toggle")
				// }}


				// onGroupExpandChanged={() => {
				// 	alert("aaa")
				// }}

				// onColumnDragged={data => {
				// 	console.log("column drag data: ", data)
				// }}


				// onGroupRemoved={(groupedColumn, index) => {
				// 	console.log("Grouped Column: ", groupedColumn)
				// 	console.log("Grouped Index: ", index)

				// 	unGroupingState(groupedColumn)
				// 	// unGroupingState(groupedColumn)

				// }}

				// onSelectionChange={(data) => {
				// 	// console.log("select data (current drawing): ", data)
				// }}
				
				onRowClick={(event, selectedDrawing) => {
					setSelectedDrawingRowId(selectedDrawing.tableData.id)

					setSelectedDrawingRecord(selectedDrawing)
					drawingDetailDialogHandleOpen()
				}}

				localization={{
					header : {
						actions: ""
					},

					grouping: {
						groupedBy: ""
					}
				}}

				options={{
					showTitle: true,
					toolbar: dataTableToolbarOpen,
					grouping: false,
					paging: false,
					selection: false,
					search: false,
					filtering: true,
					draggable: true,

					minBodyHeight: "100px",
					maxBodyHeight: "450px",

					headerStyle: {
						backgroundColor: oceanBlueColor[10],
						fontFamily: "Gill Sans, sans-serif",
						fontWeight: "bold",
						fontSize: "16px",
						// color: grayColor[8],
						color: whiteColor,
					},

					rowStyle: rowData => ({
						backgroundColor: selectedDrawingRowId === rowData.tableData.id ? oceanBlueColor[0] : "",
						fontSize: "14px",
						fontFamily: "Gill Sans, sans-serif",
					}),

					// cellStyle: { 
					// 		// backgroundColor: '#039be5',
					// 	fontFamily: "Gill Sans, sans-serif",
					// 		// color: '#FFF',
					// 		// height: 200,
					// 		// maxHeight: 200
					// 	}
				}}
			/>
		</Fragment>
	)
}


export default ViewCoverDrawingTable